import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconPanelSidebar = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M21.103 2.005q.099.01.193.039l.015.005.07.025.037.018.052.025.021.013a1 1 0 0 1 .138.093l.015.013a1 1 0 0 1 .344.62q.005.024.007.048Q22 2.952 22 3v19H2V3a1 1 0 0 1 1-1h18zM3.5 20.5H13V4H3.5zM16 13a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0-4a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0-4a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2z"
    />
  </NcIcon>
);
export { NcIconPanelSidebar };
